module.exports = __webpack_public_path__ + "static/img/icon-apply-success.48359ced.png";